export const formatAmountAsString = (amount: string) => {
  const number = parseFloat(amount);

  return `${Number.isInteger(number) ? number : number.toFixed(2)}`;
};

export const roundToCents = (amount: number) => {
  return Math.round(amount * 100) / 100;
};

export const formatAmount = (amount: number) => {
  return formatAmountAsString(`${roundToCents(amount)}`);
};
